import * as React from 'react';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-grid.css';
import { StepsModalWizardContextProvider } from '../shared/modals/multi-page-modal/use-multi-page-wizard';
import { MultiPageModal } from '../shared/modals/multi-page-modal/multi-page-modal';
import { StartupPageModal } from './startup-page-modal';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { FocusFile } from '../shared/file-importer/types';
import { FocusImportProvider } from './use-focus-import';
import { AlignPeriodsScreen } from './content/align-periods-screen';
import { TagImportScreen } from './content/tag-import-screen';
import { AthleteParticipationScreen } from './content/athlete-participation-screen';
import { MapAthletesScreen } from './content/map-athletes-screen';
import { FocusImportSelectionsProvider } from './use-focus-import-selections';
import { useGetDeepActivity } from '../api';
import { NoPeriodsDialog } from './no-periods-dialog';
import { useFocusStoredOptions } from './use-focus-stored-options';
import { BakingProcessDialog } from './baking-process-dialog';

interface ImportDialogProps {
    open: boolean;
    onClose: (isOpen: boolean) => void;
}

const getIdFromURL = (path: string) => {
    const splitPath = path.split('/');
    return splitPath[splitPath.length - 1];
};

const paths: Record<string, JSX.Element[]> = {
    tactical: [
        <AlignPeriodsScreen key={'align-periods-screen'} />,
        <TagImportScreen key={'tag-import-screen'} />,
        <AthleteParticipationScreen key={'athlete-participation-screen'} />,
    ],
    athlete: [<AlignPeriodsScreen key={'align-periods-screen'} />, <MapAthletesScreen key={'map-athletes-screen'} />],
};

export const ImportDialog: React.FC<ImportDialogProps> = (props) => {
    const { open, onClose } = props;
    const [pathOption, setPathOption] = useState<string>();
    const location = useLocation();
    const activityId = getIdFromURL(location.pathname);
    const [focusFile, setFocusFile] = useState<FocusFile | undefined>(undefined);
    const { data, isLoading } = useGetDeepActivity(activityId);
    const { focusStoredOptions } = useFocusStoredOptions();

    if (focusFile && focusStoredOptions.isBaking) {
        return <BakingProcessDialog open={open} onClose={onClose} />;
    }

    if (isLoading || data?.[0].periods?.length === 0 || data?.[0].athletes?.length === 0) {
        return <NoPeriodsDialog isLoading={isLoading} setIsOpen={onClose} />;
    }

    return (
        <FocusImportSelectionsProvider>
            <FocusImportProvider activityId={activityId} setFocusFile={setFocusFile} focusFile={focusFile}>
                <StepsModalWizardContextProvider
                    steps={[
                        <StartupPageModal key="startup-page" setPathOption={setPathOption} />,
                        ...(pathOption ? paths[pathOption] : []),
                    ]}
                >
                    <MultiPageModal handleClose={onClose} isOpen={open}></MultiPageModal>
                </StepsModalWizardContextProvider>
            </FocusImportProvider>
        </FocusImportSelectionsProvider>
    );
};
